module.exports = __webpack_public_path__ + "phone_iphone.9a9150195b8d17e6d71a7bf37f2b56e9.png";